var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrophoneOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4.5 10.5C5.05228 10.5 5.5 10.9477 5.5 11.5C5.5 14.7223 8.26435 17.376 11.7537 17.4958L13.6128 19.356C13.4111 19.3925 13.207 19.4223 13.0006 19.4451L13 21.5C13 22.0523 12.5523 22.5 12 22.5C11.4872 22.5 11.0645 22.114 11.0067 21.6166L11 21.5L11.0003 19.4452C6.78834 18.9803 3.5 15.6139 3.5 11.5C3.5 10.9477 3.94772 10.5 4.5 10.5ZM19.5 10.5C20.0523 10.5 20.5 10.9477 20.5 11.5C20.5 13.244 19.9091 14.8536 18.9073 16.1648L17.4757 14.7325C18.1245 13.7978 18.5 12.6875 18.5 11.5C18.5 10.9477 18.9477 10.5 19.5 10.5ZM12 1.5C14.4143 1.5 16.3845 3.40124 16.4951 5.78816L16.5 6V11C16.5 11.7946 16.294 12.5412 15.9326 13.1891L14.4102 11.6664C14.4547 11.505 14.4835 11.3371 14.4947 11.1644L14.5 11V6C14.5 4.61929 13.3807 3.5 12 3.5C10.6745 3.5 9.58996 4.53154 9.50532 5.83562L9.5 6V6.757L7.63699 4.89376C8.12998 2.94337 9.89643 1.5 12 1.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20 21.5L4 5.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneOff);
export default __webpack_public_path__ + "static/media/microphone-off.65d93ab1.svg";
export { ForwardRef as ReactComponent };